<template>
  <v-card class="rounded-lg mt-4">
    <v-toolbar color="primary" density="compact">
      <v-icon class="ml-4" size="small">mdi-car</v-icon>
      <v-toolbar-title class="text-subtitle-2 font-weight-bold ml-2">AUTOS ALQUILADOS</v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-data-table :headers="headers" :items="alquileres" item-key="id" density="comfortable" hide-default-footer v-if="alquileres.length" />
      <div v-else class="text-medium-emphasis text-body-2 py-2">Este alumno aún no tiene autos alquilados.</div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    alquileres: Array,
    headers: Array,
  },
};
</script>
